import { LocalizationContext } from 'app/localization/Context';
import React, { Fragment, useCallback, useContext, useMemo } from 'react';
import { HistoryStackContext } from 'app/home/general-components/HistoryStackContext';
import { AmplifierMode } from 'app/model/Device';

import { ReactComponent as IconStatusON } from 'images/device/status-text-icon/on-white.svg';
import { ReactComponent as IconStatusONFa } from 'images/device/status-text-icon/on-white-fa.svg';
import { ReactComponent as IconStatusONAr } from 'images/device/status-text-icon/on-white-ar.svg';
// import { ReactComponent as IconOff } from 'images/device/audio-controller/off.svg';
import { ReactComponent as IconOn } from 'images/device/audio-controller/on.svg';
import { ReactComponent as IconPlaylistEditBordered } from 'images/device/audio-controller/playlist-edit-bordered.svg';
import { ReactComponent as IconPlaylistEdit } from 'images/device/audio-controller/playlist-edit.svg';
import { ReactComponent as IconTickWhite } from 'images/general/tick-white.svg';
import { ReactComponent as IconSpeakerWhite } from 'images/device/audio-controller/speaker-white.svg';
// import { ReactComponent as IconSpeakerWhiteAnimated } from 'images/device/audio-controller/speaker-white-animated.svg';
import { ReactComponent as IconPauseSmall } from 'images/device/audio-controller/pause-small.svg';
import { ReactComponent as IconDisconnect } from 'images/general/disconnect.svg';


import "./AudioControllerDetail.scss"

export function AudioControllerDetail({ device, currentUser }) {
    const hs = useContext(HistoryStackContext);
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const a = s.audioController;

    const tracks = useMemo(() => {
        if (device.track_list === undefined) {
            return [];
        }
        const list = [...device.track_list];
        if ((device.track_list_pointer !== undefined) &&
            (device.track_list_pointer >= 0) &&
            (device.track_list_pointer < list.length)) {
            const i = device.track_list_pointer;
            list[i] = { ...list[i] };
            list[i]["currentTrack"] = true;
            list[i]["isPlaying"] = device.track_is_playing;
        }
        return list;
    }, [device]);

    const connected = (device.active === true);

    const selectMusicListH = useCallback(() => {
        hs.push(
            "/devices/detail/select-music-list",
            { deviceMac: device.mac, connected })
    }, [device.mac, connected, hs]);

    const on = (device.is_on === true);
    const hinavaMode = (device.mode === AmplifierMode.hinava);
    const withTrackList = (device.track_list !== undefined) && (device.track_list.length > 0);

    let showPlaylistHeader = true;
    let showPlaylistEditButtonInHeader = true;
    let specialCases = undefined;
    if (!on) {
        showPlaylistHeader = false;
        showPlaylistEditButtonInHeader = false;
        specialCases = "deviceIsOff";
    } else if (!hinavaMode) {
        showPlaylistHeader = false;
        showPlaylistEditButtonInHeader = false;
        specialCases = "modeIsNotHinava";
    } else if (!withTrackList) {
        showPlaylistHeader = true;
        showPlaylistEditButtonInHeader = false;
        specialCases = "currentPlaylistEmpty";
    }
    showPlaylistEditButtonInHeader =
        showPlaylistEditButtonInHeader &&
        currentUser.permissions.device.change_state;


    return (
        <Fragment>
            {/* DC Lable */}
            {connected ? null : <div className="connection">
                <div className="label connection-label">{s.deviceDC}</div>
                <IconDisconnect className="icon" />
            </div>}

            {/* Header */}
            {showPlaylistHeader ?
                <div className={connected ? "playlist-header" : "playlist-header tinner-top-margin"}>
                    <div className="text">{a.currentPlaylist}</div>
                    <div />
                    {showPlaylistEditButtonInHeader ?
                        <IconPlaylistEditBordered onClick={selectMusicListH} className="button" />
                        : null}
                </div>
                : null}

            {/* Special Info */}
            {(specialCases === "deviceIsOff") ? <Fragment>
                <div className="info bigger-top-margin">{a.deviceIsOff}</div>
                <div className="info-button" onClick={() => { device.changeState({ is_on: true }) }}>
                    <div className="text">{a.turnDeviceOn}</div>
                    <IconOn className="icon" />
                </div>
            </Fragment> : null}
            {(specialCases === "modeIsNotHinava") ? <Fragment>
                <div className="info bigger-top-margin">{a.modeIsNotHinava}</div>
                <div className="info-button" onClick={() => { device.changeState({ mode: AmplifierMode.hinava }) }}>
                    <div className="text">{a.setHinavaMode}</div>
                    <IconTickWhite className="icon" />
                </div>
            </Fragment> : null}
            {(specialCases === "currentPlaylistEmpty") ? <Fragment>
                <div className="info">{a.currentPlaylistEmpty}</div>
                <div className="info-button" onClick={currentUser.permissions.device.change_state ? selectMusicListH : undefined}>
                    <div className="text">{a.currentPlaylistEdit}</div>
                    <IconPlaylistEdit className="icon" />
                </div>
            </Fragment> : null}

            {/* Track List */}
            {(specialCases === undefined) ? <div className="tracks">
                {tracks.map((elem, index) =>
                    <Fragment key={"music-controller-detail-tracks-row-fragment-" + String(index)}>
                        <div className="row" key={"music-controller-detail-tracks-row-" + String(index)}
                            onClick={() => { device.changeState({ track_list_pointer: index }) }}>
                            {(elem["currentTrack"] === true) ? (
                                (elem["isPlaying"] === true) ? (
                                    <IconSpeakerWhite className="index-icon" />
                                ) : (
                                    <IconPauseSmall className="index-icon" />
                                )
                            ) :
                                <div className="index">{formatDigit(index + 1)}</div>
                            }
                            <div className="title">{elem.name}</div>
                            <div className="artists">{elem.artists}</div>
                            <div className="duration">{
                                String(formatDigit(Math.floor(elem.duration / 60))) + ":" +
                                String(formatDigit(elem.duration % 60))}
                            </div>
                        </div>
                        {index !== (tracks.length - 1) ? <div className="bar" key={"music-controller-detail-tracks-row-bar-" + String(index)} /> : null}
                    </Fragment>
                )}
            </div> : null}
        </Fragment>
    );
}

function formatDigit(d) {
    return d < 10 ? ("0" + String(d)) : String(d);
}

export function AudioControllerOnOff({ device }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    let onLabel = null;
    if (l.language === 'en') {
        onLabel = <IconStatusON className="on-icon" />;
    } else if (l.language === 'fa') {
        onLabel = <IconStatusONFa className="on-icon" />;
    } else if (l.language === 'ar') {
        onLabel = <IconStatusONAr className="on-icon" />;
    }

    const onClickH = useCallback((on) => {
        return (event) => {
            event.preventDefault();
            device.changeState({ is_on: on });
        }
    }, [device]);


    if (!device.is_on) {
        onLabel = <div className="off-label">{s.off}</div>;
    }

    // no need for loading because:
    // 1. waiting style + color is incorrect.
    // 2. the button disappears when user click it to make it OFF.

    // const shouldShowWaiting = device.waitingForChangeState["is_on"] &&
    //     !device.waitingForChangeState["is_on"].ignoreWaiting;
    // if (shouldShowWaiting) {
    //     if (device.is_on) {
    //         onLabel = <IconThreeDotsLoadingGradient className="dots-icon" />;
    //     } else {
    //         onLabel = <IconThreeDotsLoadingGray className="dots-icon" />;
    //     }
    // }

    // if (device.active) {
    if ((device.is_on) && (device.active === true)) {
        return (
            <div className="audio-controller-on-off-button" onClick={onClickH(false)}>
                <div />
                <IconOn className="icon" />
                {onLabel}
                <div />
            </div>
        );
    } else {
        return null;
        // return (
        //     <div className="audio-controller-on-off-button" onClick={onClickH(true)}>
        //         <div />
        //         <IconOff className="icon" />
        //         {onLabel}
        //         <div />
        //     </div>
        // );
    }
    // } else {
    //     return null;
    // }
}